import React from 'react';

const AppTheme=(props)=>(
    <div className='app-theme'>
        {props.children}
    </div>
);

export default AppTheme;